// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { MessageProcessorBase } from "./MessageProcessorBase.ts"
import { DirectCrossratesPlanMessage } from "../../../../Utils/DirectMessages/DirectMessagesImport.ts";
import { CrossRateData } from "../../../../Utils/CrossRate/CrossRateData.js";
import { MarkupData } from "../../../../Utils/CrossRate/MarkupData.js";
export let CrossRatesPlanMessageProcessor = function ()
{
    MessageProcessorBase.call(this)
}

CrossRatesPlanMessageProcessor.prototype = Object.create(MessageProcessorBase.prototype)

CrossRatesPlanMessageProcessor.prototype.decode = function (fieldSet)
{
    let factory = FieldsFactory

    let cpm = new DirectCrossratesPlanMessage()
    cpm.Id = fieldSet.GetValue(factory.FIELD_ID)
    cpm.Name = fieldSet.GetValue(factory.FIELD_NAME)
    cpm.Description = fieldSet.GetValue(factory.FIELD_DESCRIPTION)
    cpm.CounterAccountID = fieldSet.GetValue(factory.FIELD_COUNTER_ACCOUNT_ID)
    cpm.MarkupMeasure = fieldSet.GetValue(factory.FIELD_CROSS_MARKUP_MEASURE)

    let entrygroups = fieldSet.GetGroups(factory.MARKUP_ENTRY_GROUP)
    let len = entrygroups.length
    for (let i = 0; i < len; i++)
    {
        let entry = entrygroups[i]

        let groups = entry.GetGroups(factory.CROSS_MARKUP_GROUP)
        let res = new Array(groups.length)

        for (let j = 0, j_len = groups.length; j < j_len; j++)
        {
            let resItem = new CrossRateData()
            let group = groups[j]
            res[j] = resItem
            resItem.Exp1 = group.GetValue(factory.FIELD_NAME_EXP1)
            resItem.Exp2 = group.GetValue(factory.FIELD_NAME_EXP2)
            resItem.Price = group.GetValue(factory.FIELD_CROSS_MARKUP)
        }

        let instrId = entry.GetValue(factory.FIELD_INSTRUMENTTYPE_ID)
        if (instrId === -2)
        {
            cpm.NonTradableMarkups = res
        } else
        {
            let formula = entry.GetValue(factory.FIELD_MARKUP_FORMULA_TYPE)
            cpm.MarkupData.push(new MarkupData(instrId, formula, res))
        }
    }

    return [cpm]
}
